var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntelligent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "z03_\u667A\u80FD\u5BA1\u65B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.24,32a1.91,1.91,0,0,0-1.53.76l-6.93,9.12-4.5-3.24a2,2,0,0,0-1.13-.36,1.91,1.91,0,0,0-1.56.8,1.93,1.93,0,0,0,.44,2.7l5.34,3.84A2.74,2.74,0,0,0,30.19,45l7.59-10a1.93,1.93,0,0,0-.37-2.7A1.89,1.89,0,0,0,36.24,32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.21,4H12A4,4,0,0,0,8,8V56a4,4,0,0,0,4,4H55.21A4.8,4.8,0,0,0,60,55.21V8.79A4.8,4.8,0,0,0,55.21,4ZM43.71,55.5H12.5V8.5H43.71Zm11.79-.29a.29.29,0,0,1-.29.29H48.39V8.5h6.82a.29.29,0,0,1,.29.29Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.93,21.87H35.14a2.44,2.44,0,0,0,0-4.87H21.93a2.44,2.44,0,0,0,0,4.87Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligent);
export default __webpack_public_path__ + "static/media/Intelligent.95574930.svg";
export { ForwardRef as ReactComponent };